import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_EMAIL_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_EMAIL_FORM_TYPE = 'postermywall-email-form';

const EMAIL_FORM_DATA_ATTR = 'data-is-pmw-email-form';
const EMAIL_FORM_ID = 'postermywall-email-form';

export const POSTERMYWALL_EMAIL_FORM: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'FORM' && el.getAttribute(EMAIL_FORM_DATA_ATTR) === '1' ? {type: POSTERMYWALL_EMAIL_FORM_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'form',
      toolbar: [],
      name: window.i18next.t('pmwjs_form_maker_name_email_form'),
      draggable: false,
      hoverable: false,
      selectable: false,
      highlightable: false,
      droppable: false,
      badgable: false,
      copyable: false,
      removable: false,
      editable: false,
      attributes: {
        method: 'POST',
        id: EMAIL_FORM_ID,
        class: 'js-form',
        action: '',
        [EMAIL_FORM_DATA_ATTR]: '1',
        'data-pmw-type': POSTERMYWALL_EMAIL_FORM_TYPE,
      },
      style: FORM_EMAIL_STYLES,
    },
  },
};
